import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import authReducer from './slices/authSlice';
import chatReducer from './slices/chatSlice';
import returnChatReducer from './slices/returnChatSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  chat: chatReducer,
  returnChat: returnChatReducer,
});

const persistConfig = {
  key: 'root',
  storage,            // sessionStorage; survives reloads
  whitelist: ['auth'],// only persist auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
